import itemsDuck from './ducks/items';
import queryDuck from './ducks/query';

export const {
  getError: getParkingWhitelistError,
  getItemsIds: getParkingWhitelistIds,
  getItemsMeta: getParkingWhitelistMeta,
  getItemsTotalCount: getParkingWhitelistTotalCount,
  isLoadingItems: isLoadingParkingWhitelist,
} = itemsDuck.selectors;

export const { getFilters, getPage, getLimit, getSort } = queryDuck.selectors;
